/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Section_LabelInputs */



/**
* | output |
* | --- |
* | "Attributes" |
*
* @param {Paste_Attributes_Section_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_section_label = /** @type {((inputs?: Paste_Attributes_Section_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Section_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Attributs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Attribute")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attributi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Атрибуты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Atributos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("属性")
	if (locale === "ja") return /** @type {LocalizedString} */ ("属性")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गुण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atributos")
	return /** @type {LocalizedString} */ ("Attributes")
});